import { defineMessages } from 'react-intl';

const scope = 'app.components.ApaleoConnect';

export default defineMessages({
    buttonConnect: {
        id: `${scope}.connectButton.connect`,
        defaultMessage: 'Connect with apaleo',
    },
    buttonConnecting: {
        id: `${scope}.connectButton.connecting`,
        defaultMessage: 'Connecting with apaleo',
    },
    buttonConnectError: {
        id: `${scope}.connectButton.connectError`,
        defaultMessage: 'Error connecting with apaleo - click to retry',
    },
});
